import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=034b9012&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=034b9012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034b9012",
  null
  
)

export default component.exports